import { render } from "./MenuMobileLinks.vue?vue&type=template&id=0d18f920&scoped=true"
import script from "./MenuMobileLinks.js?vue&type=script&lang=js&external"
export * from "./MenuMobileLinks.js?vue&type=script&lang=js&external"

import "./MenuMobileLinks.scss?vue&type=style&index=0&id=0d18f920&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d18f920"]])

export default __exports__